import React, { PropsWithChildren } from "react";
import { Info as InfoIcon } from "@mui/icons-material";

import { BlockSpinner, Message, NonIdealState } from "fond/widgets";

import { BomStatus } from "./useInteractiveBomStatus";

interface InteractiveBomStatusProps {
  status: BomStatus;
}

const InteractiveBomStatus: React.FC<PropsWithChildren<InteractiveBomStatusProps>> = ({
  status,
  children,
}: PropsWithChildren<InteractiveBomStatusProps>) => {
  switch (status.kind) {
    case "planner-running":
      return (
        <NonIdealState
          icon={<BlockSpinner />}
          title="Project is currently running"
          description="The bill of materials will load once the project has finished executing. Please return to the previous page."
        />
      );
    case "loading":
      return <NonIdealState icon={<BlockSpinner />} description="Loading the bill of materials..." />;
    case "planner-no-bom":
      return (
        <Message data-testid="no-bom" type="info" typography="h6" icon={<InfoIcon />}>
          To see the bill of materials for this project, first generate a design.
        </Message>
      );
    case "unavailable":
      return (
        <Message data-testid="bom-unavailable-message" type="info" typography="h6" icon={<InfoIcon />}>
          The bill of materials is not available for this project.
        </Message>
      );
    case "no-bom":
      return (
        <Message data-testid="bom-error-message" type="info" typography="h6" icon={<InfoIcon />}>
          The bill of materials could not be loaded.
        </Message>
      );
    case "ready":
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{children}</>;
    default:
      return null;
  }
};

export default InteractiveBomStatus;
